import { Keyboard, Platform, type KeyboardTypeOptions } from 'react-native';

/** Shared nativeID for the iOS Done bar on number / decimal / phone pads. */
export const KEYBOARD_DONE_ACCESSORY_ID = 'moneylens.keyboard.done';

type PadKind = 'number' | 'decimal' | 'phone';

const PAD_KEYBOARD: Record<PadKind, KeyboardTypeOptions> = {
  number: 'number-pad',
  decimal: 'decimal-pad',
  phone: 'phone-pad',
};

/**
 * iOS number/phone pads have no Return key. Attach the shared Done accessory
 * and show a Done action on Android.
 */
export function numberPadInputProps(kind: PadKind = 'number') {
  return {
    keyboardType: PAD_KEYBOARD[kind],
    returnKeyType: 'done' as const,
    blurOnSubmit: true,
    ...(Platform.OS === 'ios'
      ? { inputAccessoryViewID: KEYBOARD_DONE_ACCESSORY_ID }
      : null),
  };
}

/** First tap dismisses the keyboard; second tap runs `onClose`. */
export function dismissKeyboardThen(onClose: () => void): void {
  if (typeof Keyboard.isVisible === 'function' && Keyboard.isVisible()) {
    Keyboard.dismiss();
    return;
  }
  onClose();
}
